// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_TOPICS = "Zp\u011bt na kategorie";
export const IN_DISCUSSION = "V diskuzi";
